<template lang="pug">
pr-wrapper(v-nv:scope="'standby'" fs bg="darken" nv-exit-protect)
    .standby(v-nv)
</template>

<script>
export default {
  name: "standby",
  activated() {
    return _$.nav.sync("standby", true)
  }
}
</script>

<style lang="scss" scoped></style>
